<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
      </div>
      <div class="posi-over">
        {{ dataVal.content }}
      </div>

      <div class="posi-btn">
        <div @click="handleSubmit">{{ dataVal.btn1 || "确定" }}</div>
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      imageUrl: "",
      county: "",
      flag: false,
    };
  },
  mounted() {},
  methods: {
    //提交
    handleSubmit() {
      if (!this.flag) {
        this.flag = true;
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("popupCell", obj);
        setTimeout(() => {
          this.flag = false;
        }, 2000);
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("popupCell", obj);
    },
    //上传头像
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //省市区选择
    handleChange(value) {
      console.log(value); //打印出城市code值
      this.getCodeToText(value); //转换城市名称方法
    },
    //转换城市名称方法
    getCodeToText(val) {
      let cityNmae = "";
      switch (val.length) {
        case 1:
          cityNmae += codeToText[val[0]];
          break;
        case 2:
          cityNmae += codeToText[val[0]] + "/" + codeToText[val[1]];
          break;
        case 3:
          cityNmae +=
            codeToText[val[0]] +
            "/" +
            codeToText[val[1]] +
            "/" +
            codeToText[val[2]];
          break;
        default:
          break;
      }
      console.log(cityNmae);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.flag = false;
      },
      deep: true,
    },
  },
};
</script>
  <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 504px;
  height: 202px;
  border-radius: 25px;
  background-color: #fff;
  .posi-head {
    padding: 26px 64px 0 41px;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 28px;
      color: #606060;
      cursor: pointer;
    }
  }
  .posi-over {
    font-size: 16px;
    color: #000000;
    margin-top: 27px;
    padding-left: 84px;
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-left: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>